module.exports = __webpack_public_path__ + "img/bb_g3_eyes-01.ae9f02e7.svg";